import React from 'react'
import { RBM_ELEMENT_ERRORS_MESSAGES, RBM_ELEMENT_ERRORS } from '../constants'
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'

const TextMsgForm = ({ elementInfo, setInfo, errors }) => {
  const handleInfoChange = (e) => {
    setInfo((prev) => ({ ...prev, text: e.target.value }))
  }
  return (
    <div>
      <label
        htmlFor="msgText"
        className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2"
      >
        <ChatBubbleLeftRightIcon className="h-4 w-4 text-gray-400" />
        Texto del mensaje
      </label>
      <textarea
        value={elementInfo.text || ''}
        name="msgText"
        id="msgText"
        rows={5}
        className="block w-full resize-y rounded-lg border-gray-300 px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm transition-colors"
        placeholder="Escribe el contenido del mensaje..."
        onChange={handleInfoChange}
      />
      {errors.includes(RBM_ELEMENT_ERRORS.EMPTY_TEXT) && (
        <p className="text-red-500 text-xs mt-1.5">
          {RBM_ELEMENT_ERRORS_MESSAGES[RBM_ELEMENT_ERRORS.EMPTY_TEXT]}
        </p>
      )}
    </div>
  )
}

export default TextMsgForm
